/* eslint-disable no-unsafe-optional-chaining */
import { useContext, useState, useEffect, useCallback } from 'react'
import { Checkbox, RadioButton2, Select2 } from 'components/index'
import { UserContext } from 'context/userContext'
import { useFetch, useStorage } from 'hooks'
import { optionsLevels } from 'helper/utils'
import { handleCaptation, selectOptions, fixName } from './factory'
import ClientSelection from './ClientSelection'

interface Captation {
  id: string
  name: string
  ruleList: string
  [key: string]: any
}

interface Enterprise {
  id: string
  name: string
  [key: string]: any
}

const PropostaBase = ({
  empreendimento,
  handleSelectEnterprise,
  data,
}: any) => {
  return (
    <div>
      <Select2
        dataTestId="enterprise-select"
        large
        hasAsterisk
        placeholder="Selecionar empreendimento"
        name="enterpriseId"
        options={empreendimento}
        onChange={(e: any) => handleSelectEnterprise(e)}
        value={empreendimento?.find(
          (empre: any) => empre.id === data?.enterpriseId
        )}
      />
    </div>
  )
}

const CaptionType = ({
  setOptions,
  setIsCaptationsSelected,
  setIsEnpreendimentoSelected,
}: any) => {
  const [empreendimento, setEmpreendimento] = useState<any>([])
  const [captations, setCaptations] = useState<any>([])
  const { setData, toggleCap, checkbox, setCheckbox, setRadioBtnValue, data } =
    useContext(UserContext)
  const [user] = useStorage('User')
  const api = useFetch()
  const isPersonal = toggleCap === 'Proposta personalizada'
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )

  const handleSelectEnterprise = (entr: any) => {
    api
      .fetch('get', null, `/gestor/enterprise?id=${entr?.id}`)
      .then((r: any) => {
        delete r.data.data.style
        // Atualizar valores de nome baseado no tipo de captacao
        const fixedData = fixName(r.data.data, isPersonal, entr)
        setData(fixedData)
      })
      .catch((e) => console.error(e))
  }

  const handleSetCaption = (e: any) => {
    // console.log('no options', e)
    const newD = handleCaptation(e, selectOptions, toggleCap)
    setData(newD)
    console.log('newD', newD)
  }

  // console.log(data)

  const getEnterprises = useCallback(async () => {
    try {
      const [capRes, enterRes] = await Promise.all([
        api.fetch('get', null, '/gestor/captations?filter=availableOnly'),
        api.fetch('get', null, '/gestor/enterprise?filter=availableOnly'),
      ])
      //
      // console.log('cap crua', capRes.data.data)

      const filteredCaptations = capRes.data.data
        .filter((item: Captation) => {
          const list = Object.keys(item.ruleList)
          return (
            list.length === 0 &&
            item.available > 0 &&
            (item.status === 'ICO' ||
              item.status === 'AVAILABLE' ||
              item.status === 'JUST_AVAILABLE')
          )
        })
        .map((ent: Captation) => ({
          ...ent,
          label: ent.name,
          value: ent.id,
        }))

      const mappedEnterprises = enterRes.data.data.map((ent: Enterprise) => ({
        ...ent,
        label: ent.name,
        value: ent.id,
      }))

      setCaptations(filteredCaptations)
      setEmpreendimento(mappedEnterprises)
    } catch (err) {
      console.error(err)
    }
  }, [setCaptations, setEmpreendimento])

  useEffect(() => {
    if (data?.ruleList?.REQUIRED_ACCOUNT > 1) {
      setRadioBtnValue('Investimento em grupo')
    }
    setRadioBtnValue('Selecionar cliente')
    if (isPersonal && optionsLevels[user.level] === 'SPECIALIST') {
      setOptions([
        ['Proposta base', 'Proposta base', true],
        ['Proposta personalizada', 'Proposta personalizada'],
        // ['Investimento realizado', 'Investimento realizado', true],
      ])
    }
    if (
      optionsLevels[user.level] === 'SPECGESTOR' ||
      optionsLevels[user.level] === 'GESTOR'
    ) {
      setOptions([
        ['Proposta base', 'Proposta base', true],
        ['Proposta personalizada', 'Proposta personalizada'],
        // ['Investimento realizado', 'Investimento realizado'],
      ])
    }

    const cooldown = setTimeout(getEnterprises, 200)

    return () => {
      clearTimeout(cooldown)
    }
  }, [])

  // Monitora se há um valor selecionado em "empreendimento" ou "captations"
  useEffect(() => {
    const handleCaptionsSelect = !!captations?.find(
      (cap: any) => cap.id === data?.captationId
    )
    setIsCaptationsSelected(handleCaptionsSelect)

    const handleEmpreendimentoSelect = !!empreendimento?.find(
      (empre: any) => empre.id === data?.enterpriseId
    )
    setIsEnpreendimentoSelected(handleEmpreendimentoSelect)
  }, [empreendimento, captations, data])

  // Reseta os valores de "empreendimento" e "captations" quando o checkbox muda
  useEffect(() => {
    setData((prevData: any) => ({
      ...prevData,
      enterpriseId: null,
      captationId: null,
    }))
  }, [checkbox])

  if (!isPersonal)
    return (
      <PropostaBase
        data={data}
        empreendimento={empreendimento}
        handleSelectEnterprise={handleSelectEnterprise}
      />
    )
  return (
    <>
      <div className="new-token-checkbox">
        <Checkbox
          label="Utilizar a base de uma captação pré-existente"
          setChecked={setCheckbox}
          checked={notUperLevel ? true : checkbox}
          disabled={notUperLevel}
        />
      </div>

      {checkbox || notUperLevel ? (
        <Select2
          placeholder="Selecione uma proposta base"
          name="enterpriseId"
          large
          dataTestId="base-proposal-select"
          hasAsterisk
          options={captations}
          value={captations?.find((cap: any) => cap.id === data?.captationId)}
          onChange={(e: any) => handleSetCaption(e)}
        />
      ) : (
        <Select2
          placeholder="Selecionar empreendimento"
          name="enterpriseId"
          hasAsterisk
          dataTestId="enterprise-select"
          large
          options={empreendimento}
          value={empreendimento?.find(
            (empre: any) => empre.id === data?.enterpriseId
          )}
          onChange={(e: any) => handleSelectEnterprise(e)}
        />
      )}
      <div className="new-token-subtitle">
        <h4>Acesso ao produto</h4>
      </div>
      <div className="new-token-checkbox">
        <RadioButton2
          width={613}
          small
          data={[
            {
              value: 'Selecionar cliente',
              selected: false,
            },
            {
              value: 'Investimento em grupo',
              selected: false,
            },
          ]}
        />
      </div>
      <div className="new-token-checkbox">
        <ClientSelection />
      </div>
    </>
  )
}

export default CaptionType
